/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-21 11:44.
 */
const BaseComponent = require('common/home/view');

class WuhaiHome extends BaseComponent {}

module.exports = WuhaiHome;
